/* eslint-disable */

export enum DiscountResponseStatus {
	Unknown = -1,
	Success = 0,
	Pin = 1,
	Empty = 2,
	Expired = 3,
	ToLong = 4,
	HasWhiteSpace = 5,
	ContainsAdminDiscounts = 6,
	
}
